import { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";

/* Gemeinsamer Branchen-Zustand für Startseite: Hero-Chips, Hero-Kreisgrafik und „Wie hilft Robbie genau dir?“
   teilen eine Auswahl. Ohne Auswahl wechselt die Kreisgrafik automatisch Gastro → Handel → Verein. */
export const BRANCHEN_IDS = ["gastro", "handel", "verein", "unternehmen"];
const CYCLE = ["gastro", "handel", "verein"];

const Ctx = createContext(null);
export const useBranche = () => useContext(Ctx) || { selected: null, displayed: "gastro", round: 0, select: () => {}, tick: () => {} };

const ausUrl = () => {
  if (typeof window === "undefined") return null;
  const p = new URLSearchParams(window.location.search).get("branche");
  return BRANCHEN_IDS.includes(p) ? p : null;
};

export const BrancheProvider = ({ children }) => {
  const start = ausUrl();
  const [selected, setSelected] = useState(start);
  const [displayed, setDisplayed] = useState(start || CYCLE[0]);
  const [round, setRound] = useState(0);
  const selRef = useRef(selected);
  const idxRef = useRef(Math.max(0, CYCLE.indexOf(start)));
  useEffect(() => { selRef.current = selected; }, [selected]);

  const select = useCallback((b) => {
    const val = BRANCHEN_IDS.includes(b) ? b : null;
    setSelected(val);
    selRef.current = val;
    if (val) {
      setDisplayed(val);
      if (CYCLE.indexOf(val) >= 0) idxRef.current = CYCLE.indexOf(val);
    }
    setRound((r) => r + 1);
  }, []);

  // vom Kreisgrafik-Takt aufgerufen: eine Animationsrunde weiter, bei Auto-Betrieb nächste Branche
  const tick = useCallback(() => {
    setRound((r) => r + 1);
    if (!selRef.current) {
      idxRef.current = (idxRef.current + 1) % CYCLE.length;
      setDisplayed(CYCLE[idxRef.current]);
    }
  }, []);

  const value = useMemo(() => ({ selected, displayed, round, select, tick }), [selected, displayed, round, select, tick]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};
